<template>
  <div class="counter-component-container">
    <div class="counter">
      {{ count }}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      count: {
        type: Number,
        default: 0,
      },
    },
  };
</script>
<style lang='scss' scoped>
.counter-component-container {
  margin-right: rem-calc(16);
  text-align: left;
  width: rem-calc(40);

  .counter {
    background-color: $grey-5;
    display: inline-block;
    font-size: rem-calc(10);
    padding: rem-calc(8);

    .row:hover & {
      background-color: $grey-4;
    }
  }
}
</style>
